// extracted by mini-css-extract-plugin
module.exports = {"newNotification":"NewNotification_newNotification__ri0Yy"};